<template>
  <div class="carousel-wrapper" v-if="images">
    <div class="background" :style="render_background_current" />
    <div v-if="images.length > 1" class="thumbnailContainer">
      <div class="columns is-multiline is-centered is-mobile is-hidden-mobile">
        <div class="column is-narrow" v-for="(image, index) in images" :key="index">
          <div
            :class="[
                  highlighted(index) ? 'highlighted' : 'not-highlighted',
                  'thumbnail'
                ]"
            @click="current_index = images.indexOf(image)"
            :style="render_background_non_current(image)"
          >
            <div />
          </div>
        </div>
      </div>
      <div class="is-flex is-hidden-mobile">
        <div class="navigation navigation-desktop previous-image has-text-centered" @click="change_slide(-1)">
          <i class="fas fa-arrow-left"></i>
        </div>
        <div class="navigation navigation-desktop next-image has-text-centered" @click="change_slide(1)">
          <i class="fas fa-arrow-right"></i>
        </div>
      </div>
      <div class="is-flex is-hidden-desktop is-hidden-tablet">
        <div class="navigation previous-image has-text-centered" @click="change_slide(-1)">
          <i class="fas fa-arrow-left"></i>
        </div>
        <div class="over-flow is-flex">
          <div
            class="is-flex-direction-row py-2 px-2"
            v-for="(image, index) in images"
            :key="index"
          >
            <div
              :class="[
                  highlighted(index) ? 'highlighted' : 'not-highlighted',
                  'thumbnail'
                ]"
              @click="current_index = images.indexOf(image)"
              :style="render_background_non_current(image)"
            >
              <div />
            </div>
          </div>
        </div>
        <div class="navigation next-image has-text-centered" @click="change_slide(1)">
          <i class="fas fa-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["gym"]),
    current_slide() {
      let current_index = this.current_index;
      if (this.images) {
        return this.images.filter((image, index) => index === current_index);
      } else {
        return null;
      }
    },
    next_slide() {
      let current_index = this.current_index + 1;
      if (current_index >= this.images.length) {
        let current_index = 0;
        return this.images.filter((image, index) => index === current_index);
      } else {
        return this.images.filter((image, index) => index === current_index);
      }
    },
    prev_slide() {
      if (this.images) {
        let current_index = this.current_index - 1;
        if (current_index < 0) {
          let current_index = this.images.length - 1;
          return this.images.filter((image, index) => index === current_index);
        } else {
          return this.images.filter((image, index) => index === current_index);
        }
      }
      return null;
    },
    render_background_current() {
      return `background-image : url(${this.current_slide});`;
    },
    filterImages() {
      if (this.images) {
        return this.images.filter((image, index) => {
          return index != this.current_index;
        });
      } else {
        return null;
      }
    }
  },
  data() {
    return {
      current_index: 0,
      timer: null
    };
  },
  props: {
    images: {
      type: Array
    }
  },
  methods: {
    change_slide(delta) {
      let total = this.current_index + delta;
      if (total < 0) {
        this.current_index = this.images.length - 1;
      } else if (total >= this.images.length) {
        this.current_index = 0;
      } else {
        this.current_index += delta;
      }
    },
    render_background_non_current(image) {
      return `background-image : url(${image})`;
    },
    highlighted(index) {
      if (index == this.current_index) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    let self = this;

    document.onkeydown = function(e) {
      e = e || window.event;
      // Left arrow
      if (e.keyCode == "37") {
        self.change_slide(-1);
      } else if (e.keyCode == "39") {
        // Right arrow
        self.change_slide(1);
      }
    };
  }
};
</script>

<style scoped>
.background {
  height: 300px;
  width: 40%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow: 0 2px 5px #8a8a8a;
}

.carousel-wrapper {
  background-position: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 0;
  width: 100%;
}

.highlighted {
  border: 2px solid #00c5fd;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

.is-flex {
  align-items: center;
  justify-content: space-evenly;
}

.mobile-only-display {
  display: none;
}

.navigation {
  margin: 0.5rem;
}

.navigation-desktop:hover {
  cursor: pointer;
}

.over-flow {
  width: 100%;
  overflow-x: scroll;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.thumbnail {
  width: 150px;
  height: 100px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow: 0 2px 3px #8a8a8a;
  cursor: pointer;
}

.thumbnailContainer {
  width: 50%;
}

@media (max-width: 768px) {
  .mobile-only-display {
    display: block;
  }
  .non-mobile-display {
    display: none !important;
  }
  .carousel-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .background {
    width: 80vw;
    margin: auto;
    margin-bottom: 2rem;
  }
  .thumbnailContainer {
    width: 95%;
  }
}
</style>
